import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import type { NavigationGuardWithThis, RouteLocationNormalized } from 'vue-router';
import { RouteNames } from '../routeNames';

export const BootstrapGuard: NavigationGuardWithThis<undefined> = async (
  _: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  const globalStore = useGlobalStore();
  const policyStore = usePolicyStore();
  if (!globalStore.initialized) {
    await globalStore.bootstrap();
  }
  // Catching a user refresh, this originally was applied to TermLife however
  // we can't see the route from vue page so we don't know when to call getPolicyOverview
  // this solves the issue of multiple calls being made to getPolicyOverview as well as
  // the issue of user refreshing on Debt or Investment pages and coming over to life page directly
  // from those pages
  if ((from.fullPath === '/' && !from.name) || from.name === 'LoginCallback') {
    await policyStore.getPolicyOverview();
  }
  if (globalStore.initialized) {
    return true;
  } else if (window.appConfig.showBootstrapErrors) {
    return { name: RouteNames.ERROR };
    // TODO: report in DT
  } else {
    // TODO: report in DT
    await globalStore.goToLogin();
    return false;
  }
};
